import {
	InvoiceTemplates,
	PnlGroups,
} from '@shared/utils/constants';
import { formatCurrency } from '@shared/utils/currency';
import { ensureNegative, round } from '@shared/utils/math';
import { formatPercentage } from '@shared/utils/formatPercentage';
import TemplateItem from '../TemplateItem';
import HireInvoiceItem from './HireInvoiceItem';

class HIIDemurrageBrokerCommission extends HireInvoiceItem {
	static get itemType() {
		return 'demurrageBrokerCommission';
	}

	constructor(id, isOriginal, params) {
		super(id, isOriginal, { fixtureCurrency: params?.fixtureCurrency });

		this.brokerId = params.brokerId;
		this.brokerName = params.brokerName;
		this.percentage = params.percentage;
		this.cargoId = params.cargoId;

		this._showTotal = true;
		this.itemTypeLabel = 'Broker Commission';
		this.addManually = false;
		this.templateSection = TemplateItem.Sections.COMMISSIONS;
		this.pnlGroup = PnlGroups.BROKER_COMMISSIONS;

		this._fields = {};
	}

	_calculateTotal(invoiceItems) {
		const demurrage = this.getParent(invoiceItems);

		const total = demurrage.getRawTotal(invoiceItems) * (this.percentage / 100);

		return round(-1 * total, 2);
	}

	getDescription(invoiceItems) {
		const parent = this.getParent(invoiceItems);

		if (parent?.children.filter((c) => c instanceof HIIDemurrageBrokerCommission).length > 1) {
			return `${formatPercentage(this.percentage, 2)}, ${this.brokerName}`;
		}

		return `${formatPercentage(this.percentage, 2)}`;
	}

	static async _getClassParams(model, parentModel) {
		const broker = await model.getBroker(parentModel);

		return {
			cargoId: model.cargoId,
			brokerId: model.brokerId,
			brokerName: broker?.name,
			percentage: model.percentage ?? broker?.commission,
		};
	}

	async saveModel(model) {
		await super.saveModel(model);

		model.brokerId = this.brokerId;
		model.cargoId = this.cargoId;
		model.percentage = this.percentage;

		await model.save();
	}

	_getTemplateItemParams(invoiceItems) {
		const demurrage = this.getParent(invoiceItems);

		return {
			[InvoiceTemplates.CLASSIC]: {
				columns: ['Broker commission', this.getDescription(invoiceItems)],
			},
			[InvoiceTemplates.NEO]: {
				columns: [
					' — Broker commission',
					`${formatPercentage(this.percentage, 2, false)}`,
					'%',
					`${formatCurrency(
						ensureNegative(demurrage.getTotal(invoiceItems)),
						this.fixtureCurrency,
						{ hideSymbol: true },
					)}`,
				],
			},
		};
	}
}

HireInvoiceItem.addItemClass(HIIDemurrageBrokerCommission);

export default HIIDemurrageBrokerCommission;
